/**
 * 搜索热点
 */
"use strict";
angular.module("websiteChannelHotSpotsModule", ['hotSpotsTopModule', 'singleSelectCutModule']).
controller("websiteChannelHotSpotsCtrl", ["$scope", "trsHttpService", "$filter", "hotFocusService",  function($scope, trsHttpService, $filter, hotFocusService) {
    initStatus();
    initData();

    function initStatus() {
        $scope.status = {
            noInfo: true,
            selectedBeginTime: {
                name: '开始时间',
                value: -1
            },
            beginTimeList: [],
            jumpToPageNum: 1,
        }

        $scope.data = {
            webHotSpotsList: [],
            curWebHotSpot: {}, // 当前热点
            curWebHotSpotDetail: {}, // 当前热点详情
            areaBtnList: [], // 本省地域列表
            curArea: {}, // 当前地域
            areaRelateLists: []
        }

        $scope.page = {
            "STARTPAGE": 1,
            "PAGESIZE": 10
        };
    }

    function initData() {
        initTimeCut();
        requestWebTopData();
    }

    $scope.clickAreaList = function(item) {
        $scope.data.curArea = item;
        $scope.page = {
            "STARTPAGE": 1,
            "PAGESIZE": 10
        };
        requestAreaHotList();
    }

    /**
     * [initTimeCut description]初始化时间段控件
     * @return {[type]} [description]
     */
    function initTimeCut() {
        let hour = $filter("date")(Date.parse(new Date()), "HH");
        for (let i = 23; i >= 0; i--) {
            let name = i < 10 ? ('0' + i) : i;
            let namePlus = i + 1;
            namePlus = namePlus < 10 ? ('0' + namePlus) : namePlus;
            let nameStr = name + ':00-' + namePlus + ':00';
            $scope.status.beginTimeList.unshift({
                name: nameStr,
                value: i
            })

            if (name == hour) {
                $scope.status.selectedBeginTime = {
                    name: nameStr,
                    value: i
                }
            }
            if (i == 0) {
                $scope.status.beginTimeList.unshift({
                    name: '—— 早上 ——',
                    value: 'cut'
                })
            }
            if (i == 12) {
                $scope.status.beginTimeList.unshift({
                    name: '—— 下午 ——',
                    value: 'cut'
                })
            }
            if (i == 17) {
                $scope.status.beginTimeList.unshift({
                    name: '—— 晚上 ——',
                    value: 'cut'
                })
            }
        }
    }


    /**
     * [requestWebTopData description]网媒热点TOP5
     * @return {[type]} [description]
     */
    function requestWebTopData() {
        var params = {
            typeid: "widget",
            serviceid: "channelNetWorkMediaHotpointMgr",
            modelid: "getHotList",
            page_size: '5',
            page_no: '0',
            // hour: '10',
            // search_date:'2019-04-29' // 临时参数
        };
        params.hour = $scope.status.selectedBeginTime.value;
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
            if (data.PAGEITEMS && data.PAGEITEMS.length > 0) {
                $scope.data.webHotSpotsList = data.PAGEITEMS;
                $scope.data.curWebHotSpot = $scope.data.webHotSpotsList[0];
                if ($scope.data.curWebHotSpot.ABSTRACTS.length > 272) {
                    $scope.data.curWebHotSpot.contentlimit = $scope.data.curWebHotSpot.ABSTRACTS.substring(0, 272) + '...';
                    $scope.data.curWebHotSpot.lookFlag = true;
                }
                requestAreaList();
            }
        });
    }

    /**
     * [requestAreaList description]请求区域地址列表
     * @return {[type]} [description]
     */
    function requestAreaList() {
        var params = {
            typeid: "widget",
            serviceid: "channelNetWorkMediaHotpointMgr",
            modelid: "getAreas"
        };
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "get").then(function(data) {
            for (var i in data) {
                for (var j in data[i]) {
                    $scope.data.areaBtnList.push({
                        areaId: j,
                        areaName: data[i][j]
                    })
                }
            }
            $scope.data.curArea = $scope.data.areaBtnList[0];
            requestAreaHotList();
        });
    }

    /**
     * [requestlistList description] 请求今日头条涉及本省地域列表
     * @param  {[type]} area [description]
     * @return {[type]}      [description]
     */
    function requestAreaHotList() {
         var params = {
            typeid: "widget",
            serviceid: "channelNetWorkMediaHotpointMgr",
            modelid: "getArticles",
            id: $scope.data.curWebHotSpot.GUID,
            page_no: $scope.page.STARTPAGE-1,
            page_size: $scope.page.PAGESIZE,
            area_id: $scope.data.curArea.areaId
        };
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
            if (data.PAGEITEMS && data.PAGEITEMS.length > 0) {
                $scope.data.areaRelateLists = data.PAGEITEMS;
                $scope.page = {
                    STARTPAGE: data.PAGEINDEX+1,
                    PAGESIZE: data.PAGESIZE,
                    ITEMCOUNT: data.TOTALITEMCOUNT,
                    PAGECOUNT: data.PAGETOTAL
                }
                $scope.status.noInfo = false;
            } else {
                $scope.status.noInfo = true;
            }
        });
    }

    /**
     * [clickTopCallback description]网媒热点TOP5点击
     * @return {[type]} [description]
     */
    $scope.clickTopCallback = function() {
        if ($scope.data.curWebHotSpot.ABSTRACTS.length > 272) {
            $scope.data.curWebHotSpot.contentlimit = $scope.data.curWebHotSpot.ABSTRACTS.substring(0, 272) + '...';
            $scope.data.curWebHotSpot.lookFlag = true;
        }
        $scope.page.STARTPAGE = 1;
        $scope.data.areaBtnList = [];
        requestAreaList();
    }

    /**
     * [selectTimeCallback description]时间回调
     * @return {[type]} [description]
     */
    $scope.selectTimeCallback = function() {
        // 重置数据
        $scope.data.webHotSpotsList = [];
        $scope.data.curWebHotSpot = [];
        $scope.data.curArea = [];
        $scope.data.areaRelateLists = [];
        $scope.data.areaBtnList = [];
        $scope.page = {
            "STARTPAGE": 1,
            "PAGESIZE": 10
        };
        $scope.status.noInfo = true;
        requestWebTopData();
    }

    /**
     * [viewDetail description]查看热点详情
     * @param  {[type]} item [description]
     * @return {[type]}      [description]
     */
    $scope.viewDetail = function(item) {
        hotFocusService.showNetWork(item);
    }

    /**
     * [pageChanged description]分页请求
     * @return {[type]} [description]
     */
    $scope.pageChanged = function() {
        $scope.status.jumpToPageNum = $scope.page.STARTPAGE;
        requestAreaHotList();
    };

    $scope.jumpToPage = function() {
        if ($scope.status.jumpToPageNum > $scope.page.PAGECOUNT) {
            $scope.status.jumpToPageNum = $scope.page.PAGECOUNT;
        }
        $scope.page.STARTPAGE = $scope.status.jumpToPageNum;
        requestAreaHotList();
    };

    $scope.lookAll = function() {
        $scope.data.curWebHotSpotDetail.lookFlag = false;
    }

    $scope.lookPart = function() {
        $scope.data.curWebHotSpotDetail.lookFlag = true;
    }
}]);